import {DataFieldType} from '@frontapp/workflows/data_fields_table';
import React, {ReactNode} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {isDefined} from '../../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {dataFieldsTableColumnTypeRenderData} from '../../../../dataTable/helpers';

export function getMacroInputDefinitionRenderData(
  type: DataFieldType,
  enumValues: ReadonlyArray<string> | undefined,
): {icon: IconName; label: ReactNode} {
  const isEnumSelected = type === DataFieldType.STRING && isDefined(enumValues);
  if (isEnumSelected) {
    return {label: macroInputDropdownTypeLabel, icon: 'formattingListSmall'};
  }

  return dataFieldsTableColumnTypeRenderData[type];
}

export const macroInputDropdownTypeLabel = (
  <Trans id="macro-collect-input-type-dropdown-label">Dropdown</Trans>
);
